import * as PropTypes from "prop-types";
import SearchSvg from "./ShowMoreIcon.svg";
import Icon from "./Icon";

export default function ShowMoreIcon({ className, style }) {
  const localStyle = {
    minWidth: "1.7rem",
    minHeight: "1.7rem",
    maxWidth: "1rem",
    maxHeight: "1rem",
    ...style,
  };

  return <Icon src={SearchSvg} className={className} style={localStyle} />;
}

ShowMoreIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

ShowMoreIcon.defaultProps = {
  className: "",
  style: {},
};
